import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var HeadSideCoughSlash = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M454.11 319.21c19.56-3.81 31.62-25 23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13 208.13 0 0 0 234.1 0H192A190.64 190.64 0 0 0 84.18 33.3L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.35 454.72a16 16 0 0 0 22.47-2.81l19.64-25.27a16 16 0 0 0-2.81-22.45zM313.39 210.45 263.61 172c5.88-7.14 14.43-12 24.36-12a32.06 32.06 0 0 1 32 32c.03 7-2.73 13.17-6.58 18.45zM616 304a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm-64 64a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm-264 16a32 32 0 0 1 32-32h19.54L20.73 105.59A190.86 190.86 0 0 0 0 192c0 56.75 24.75 107.62 64 142.88V512h224v-32h64a64 64 0 0 0 64-64h-96a32 32 0 0 1-32-32zm328-24a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"
  }));
});
HeadSideCoughSlash.displayName = 'HeadSideCoughSlash';
export var HeadSideCoughSlashDimensions = {
  height: 512,
  width: 640
};